import { useEffect, useState } from 'react';

export interface UseUserCountryReturn {
    userCountry: string | null;
    isLoading: boolean;
}

// کَش سراسری برای جلوگیری از اجرای مجدد تست پینگ در یک سشن
let cachedCountry: string | null = null;
let pingPromise: Promise<string> | null = null;

export const useUserCountry = (): UseUserCountryReturn => {
    const [userCountry, setUserCountry] = useState<string | null>(cachedCountry);
    const [isLoading, setIsLoading] = useState<boolean>(!cachedCountry);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        // ۱. استفاده از دیتای کَش شده در صورت وجود
        if (cachedCountry) {
            setUserCountry(cachedCountry);
            setIsLoading(false);
            return;
        }

        // ۲. اگر تستی در حال اجرا نیست، آن را شروع کن
        if (!pingPromise) {
            pingPromise = new Promise((resolve) => {
                const img = new Image();
                let isResolved = false;

                // تابع کمکی برای پایان دادن به تست و جلوگیری از تداخل
                const finish = (country: string) => {
                    if (!isResolved) {
                        isResolved = true;
                        resolve(country);
                    }
                };

                // اگر تصویر با موفقیت لود شد -> یوتیوب باز است (VPN روشن یا خارج از ایران)
                img.onload = () => finish('US'); // 'US' نماد دسترسی آزاد است

                // اگر تصویر خطا داد -> یوتیوب مسدود است
                img.onerror = () => finish('IR'); // 'IR' نماد مسدود بودن است

                // ⏱️ تایم‌اوت (Timeout): اگر بعد از ۲ ثانیه جوابی نیامد، فرض را بر مسدود بودن/کندی شدید می‌گذاریم
                setTimeout(() => finish('IR'), 2000);

                // تلاش برای لود کردن فاوآیکون یوتیوب به همراه یک پارامتر رندوم برای دور زدن کَش مرورگر
                img.src = `https://www.youtube.com/favicon.ico?_cb=${new Date().getTime()}`;
            });
        }

        // ۳. انتظار برای نتیجه تست و آپدیت استیت‌ها
        pingPromise.then((country) => {
            cachedCountry = country;
            setUserCountry(country);
            setIsLoading(false);
        });
    }, []);

    return { userCountry, isLoading };
};
